import { generateProof } from 'dpop';
import { Environment, Network } from 'relay-runtime';
import { getValidAccessToken, resetAccessToken } from '../auth/access-token';
import { getOrCreateKeyPair } from '../auth/dpop';
import { getBackendOrigin } from '../auth/backend-origin';

// https://relay.dev/docs/migration-and-compatibility/relay-hooks-and-legacy-container-apis/

const GRAPHQL_PATH = '/graphql';

export const relayEnv = new Environment({
    network: Network.create(async (request, variables) => {
        const accessToken = await getValidAccessToken();
        if (!accessToken) {
            throw new Error('Access Token konnte nicht abgerufen werden.');
        }
        const resp = await fetch(GRAPHQL_PATH, {
            method: 'POST',
            headers: {
                Authorization: 'DPoP ' + accessToken,
                'Content-Type': 'application/json',
                DPoP: await generateProof(
                    await getOrCreateKeyPair(),
                    getBackendOrigin() + GRAPHQL_PATH,
                    'POST',
                    undefined,
                    accessToken
                ),
            },
            body: JSON.stringify({ query: request.text, variables }),
        });

        if (resp.status === 401) {
            resetAccessToken(); // Token ungültig → beim nächsten Request neu holen
        }
        if (!resp.ok) {
            throw new Error('Response failed.');
        }

        return await resp.json();
    }),
});
